import React from "react";
import "./App.css";
import {
  Router,
  Route,
  Routes,
  Navigate,
} from "./hooks/useRouter";

// Redux
import store from "./store/index.js";
import { Provider } from "react-redux";

// Contexts
import { EventEmitterProvider } from "./contexts/EventEmmiter.js";
import { ConstantsProvider } from "./constant/constantProvider.js";
import { BreadcrumbProvider } from "./contexts/BreadcrumbContext.jsx";
import { REQUIRE_AUTH } from "./constant/globalConstants.js";
import { ROUTES } from "./constant/keyConstants.js";

// Service & Layout
import ProtectedRoute from "./services/AuthGaurd.jsx";
import SessionExpiration from "./services/SessionExpiration.jsx";
import Layout from "./components/Layout/Layout.jsx";

// Pages
import Dashboard from "./pages/Dashboard/Dashboard.jsx";
import Login from "./pages/Login/Login.jsx";
import Decrypt from "./pages/Decrypt/Decrypt.jsx";
import PromptManager from "./pages/PromptManager/PromptManager.jsx";

function AppRoutes() {

  // Check if decrypt page should be shown based on URL
  const shouldShowDecrypt = () => {
    const hostname = window.location.hostname;
    return hostname.includes('localhost') || hostname.includes('dev');
  };

  const defaultRedirect = REQUIRE_AUTH ? (
    <Navigate to={ROUTES.SIGN_IN} replace />
  ) : (
    <Navigate to={ROUTES.DASHBOARD} replace />
  );

  return (
    <Routes>
      <Route path="/" element={defaultRedirect} />

      {/* Protected routes wrapped in Layout */}
      <Route element={<ProtectedRoute element={Layout} />}>
        <Route
          path={ROUTES.DASHBOARD}
          element={<Dashboard />}
        />
        <Route
          path={ROUTES.PROMPT_MANAGER}
          element={<PromptManager />}
        />
        {shouldShowDecrypt() && (
          <Route
            path={ROUTES.DECRYPT}
            element={<Decrypt />}
          />
        )}
      </Route>

      <Route path={ROUTES.SIGN_IN} element={REQUIRE_AUTH ? <Login /> : <Navigate to={ROUTES.DASHBOARD} replace />} />
      <Route path="*" element={defaultRedirect} />
    </Routes>
  );
}

function App() {
  return (
    <div className="app-container">
      <Provider store={store}>
        <ConstantsProvider>
          <EventEmitterProvider>
            <BreadcrumbProvider>
              <Router>
                <SessionExpiration>
                  <AppRoutes />
                </SessionExpiration>
              </Router>
            </BreadcrumbProvider>
          </EventEmitterProvider>
        </ConstantsProvider>
      </Provider>
    </div>
  );
}

export default App;
